import cardFilters from "./cardFilters";
import game from "./game";
import nav from "./nav";
import rules from "./rules";
import welcome from "./welcome";

export default {
  cardFilters,
  game,
  nav,
  rules,
  welcome,
};
